import { matchPath } from 'react-router-dom'

import { Client } from '@buffer-mono/tracking-plan'

import { selectCurrentOrganizationId } from '~publish/legacy/organizations/selectors'
import {
  allChannels,
  compose,
  channel,
  newCalendarAllChannels,
  newCalendarSingleChannel,
} from '~publish/legacy/routes'
import { store } from '~publish/legacy/store'

type SegmentChannelProfile = {
  id: string
  serviceId?: string
  service: {
    username?: string
    name: string
  }
  serviceType: string
}

type SegmentChannelMetadata<Page> = {
  product: 'publish'
  organizationId: string
  channelId: string
  channelServiceId: string
  channelUsername: string | undefined
  channelType: string
  channel: string
  page: Page
  clientName: typeof Client.PublishWeb
}

export const getSegmentChannelMetadata = <
  Page extends string | null | undefined,
>({
  profile,
  organizationId,
  page,
}: {
  profile: SegmentChannelProfile
  organizationId: string | null | undefined
  page: Page
}): SegmentChannelMetadata<Page> => ({
  product: 'publish',
  organizationId:
    organizationId || selectCurrentOrganizationId(store.getState()),
  channelId: profile.id,
  channelServiceId: profile.serviceId ?? '',
  channelUsername: profile.service?.username,
  channelType: profile.serviceType,
  channel: profile.service.name,
  page,
  clientName: Client.PublishWeb,
})

export const getCurrentPageName = (pathname: string): string | undefined => {
  if (matchPath(compose.route, pathname)) {
    return 'extension'
  }
  if (
    matchPath(allChannels.route, pathname) ||
    matchPath(newCalendarAllChannels.route, pathname)
  ) {
    return 'allChannels'
  }
  if (
    matchPath(channel.route, pathname) ||
    matchPath(newCalendarSingleChannel.route, pathname)
  ) {
    return 'channel'
  }
  if (matchPath('/create/feeds/:feedId', pathname)) {
    return 'feed'
  }
  if (matchPath('/create/feed/collections/:feedCollectionId', pathname)) {
    return 'feedCollection'
  }
  if (matchPath('/create/templates', pathname)) {
    return 'templates'
  }
  if (matchPath('/create', pathname)) {
    return 'ideas'
  }
}
